import type {
  FunnelEvent,
  FunnelEventRequest,
  FunnelEventResponse,
} from "~/shared/utils/types";
import { api } from "./axios";

/**
 * Send a funnel tracking event to the internal API
 */
export const sendFunnelEvent = async (
  event: FunnelEvent,
): Promise<FunnelEventResponse> => {
  try {
    const { data } = await api.post<FunnelEventResponse>("/funnel/events", {
      event,
    } as FunnelEventRequest);
    return data;
  } catch (error) {
    // Log error but don't throw - tracking should not break the app
    console.error("[FunnelTracking] Failed to send event:", error);
    return { success: false };
  }
};
